import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../reducers';

export const selectWorkflowsState = createSelector(
  (state: RootState) => state,
  (state) => state.workflows
);
